import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { Link, Route, Routes, useNavigate, useParams } from 'react-router-dom'
import { AntennaBars5, ArrowsLeftRight, Check, Edit, GripVertical, MessageCircle, Photo, Plus, Search, Settings, Subtask, Trash } from 'tabler-icons-react';
import { EditComponent , NewComponent} from './../Components';  
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { componentStatus, userPermisions } from '../../Constants/Constants';
import { Button, Drawer, Main, PageHeader, Skeleton } from '../../Components';
import { useList } from 'react-use';
import Tooltip  from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';


// import './components.css'
import { useConfirmationModal } from '../../Hooks/useNotifications';
import toast from 'react-hot-toast';
import { Helmet } from 'react-helmet';
import { SetupComponentAutomation } from '../Automations/SetupComponentAutomation';
import { randomIntInterval } from '../../Helpers';
import { NewTeamMember , EditPermissionsTeamMember } from './index'
import { useSelector } from 'react-redux';

import './team.css'
import ReactPaginate from 'react-paginate';

export function Team() {

	const effectCalled = useRef(false)
	const { organization_id } = useParams();
	const navigate = useNavigate()
	const [activeTab, setActiveTab] = useState(1);
	const { getConfirmation } = useConfirmationModal();

     // Grab the data from redux 
	const { user , org } = useSelector((state) => state.auth);
	

	 

	const [isLoading, setIsLoading] = useState(true)
	const [users, setUsers] = useList([])
	const [activePage, setActivePage] = useState(0);
	const [listPerPage, setListPerPage] = useState(10);
	const [totalRecords, setTotalRecords] = useState(0);
	const [openedRemovingTeamMember, setOpenedRemovingTeamMember] = useState(false);
	const [updatedComponent, seUpdatedComponent] = useState(0)
	 


	useEffect( () => {
		// if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			const response = await getTeamMembers({
				page : activePage ,// / listPerPage,
				per_page : listPerPage
			})
		}
		fetchData();

		// effectCalled.current = true ;
		
	}, [activePage])
 

	/**
	 * 
	 * @param {*} param0 
	 * @returns 
	 */
	const getTeamMembers = async ({ page , per_page}) => {

		return new Promise(async(resolve, reject) => { 

			setIsLoading(true)
			
			
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = {
					page : page ,
					per_page : per_page,
					 
				}

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/organizations/${org?.id}/team` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					// Total records 
					setTotalRecords(data.total);

					setUsers.set(data.data)

					setIsLoading(false)
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setUsers.set([])
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. Thank you try later.`)
						}
					}
				})
			}else{
				setIsLoading(false)
			}

		})
	}

 
	const items = users?.map((item, index) => {

		const userPermissionOrganization = userPermisions.find( x => x.value === item?.access )
        const user_email = item?.type === 'INVITE' ? item?.invited_email : item?.user?.email;

		return(
			<div key={index} className={`teamlist--item `} >
				<div className={`dragContent`}>
					<div className="status">{componentStatus.find( x => x.value === item?.status)?.icon}</div>
					<div className='title'>{user_email}{ user?.email === user_email && <span className='tag-myself'>You!</span> }</div>
					<div className='details'>
						<div className='groups mr-10'>
							{ item?.type === 'INVITE' && 
								<div className="group" size="sm" variant="light" radius="sm">Invited</div>
							}
							<div className="group" size="sm" variant="light" radius="sm">{ userPermissionOrganization?.label}</div>
						</div>
					</div>
				</div>
				<div className={`dragActionBtns`}>
					{
						user?.email !== user_email && org?.access ==='OWNER' && userPermissionOrganization?.value !=='OWNER' && 
						<>
							{
								item?.type === 'MEMBER' && 
								<Link 
									color="purple"
									className='btn btn-link btn-purple mr-10'
									to={`/team/${item?.user?.id}/permissions`}
										
									>Edit permissions</Link>
							}
							<Button 
								color="red"
								link={true}
								onClick={() => openDeleteTeamMemberModal({ user_id : item?.id , type :  item?.type})} 
								>Delete</Button>
						</>
					}
				</div>
			</div>
		)
	});

	

	const openDeleteTeamMemberModal = (params) => {

		 
		
		getConfirmation({
			size : 'small',
			type: 'danger',
			title: "Deleting team members",
			message: "Are you sure you want to delete your team member? ",
			labels: { confirm: 'Delete', cancel: "No don't delete it" },
			onConfirm : () => {
				deleteTeamMember({
					id : params?.user_id,
					type : params?.type
				})
			},
			onCancel : () => {
				 

			}
		});
	}

	/**
	 * 
	 */	
	const deleteTeamMember = ({ id , type }) => {

		

		return new Promise( async (resolve, reject) => { 
			
			// setIsLoading(true)
			 

			
			
			
			
			
			if (user && user.token && org && org?.id ) {
				 

				const token = user?.token;


				await axios.delete(`${process.env.REACT_APP_API_URL}/organizations/${org?.id}/team/${id}`, {
					params : {
						type : type
					},
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {


					let _teamMembers = [...users];
					// _teamMembers = _teamMembers.filter((p) => p.id !== USER_ID);
					const index = _teamMembers.findIndex((p) => p.id === id);

					setUsers.removeAt(index) //(_teamMembers);

					// Update the Total records 
					let _totalRecords = totalRecords
					setTotalRecords(--_totalRecords);
					// setIsLoading(false)
					toast.success('Your team member has been successfully deleted') 
					


					// components list 
					resolve(data.data)  
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					// setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
					 
				})
			}else{
				// setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})
	}

	/**
	 * 
	 */
	const closeTeamMembersForm = () => {
		navigate(`/team`)
	}

	 
	 

	let headerActionButtons = []
	if(users?.length > 0 && org?.access ==='OWNER') headerActionButtons.push({
		name : "Invite",
		link : `/team/new`,
		color : 'purple'
	} )

	 

	const SkeletonLoader_itemList = () => {
		return(
			[...Array(6)].map( (item, index) => {
				return( 
					<div key={index} className={`componentslist--item `} >
						<div className={`dragHandle`}>
							<Skeleton width={20} height={20} radius="sm" />
						</div>
						<div className={`dragContent`}>
							<div className="status"><Skeleton width={20} height={20} radius="sm" /></div>
							<div className='title'><Skeleton width={`${randomIntInterval(20 , 60)}%`} height={16} radius="sm" /></div>
						</div>
						<div className={`dragActionBtns`}>
							<Skeleton className='mr-10' width={30} height={20} radius="sm" />
							<Skeleton className='mr-10' width={30} height={20} radius="sm" />
							<Skeleton width={30} height={20} radius="sm" />
						</div>
					</div>
				)   
			})
		)  
	}


	return (
		<>
		<Helmet>
			<title>{`Team - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Team', link: `` },
			]}
			 >
				<PageHeader
					title="Team Members"
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
					actionBtns={headerActionButtons}
					/>
			 
				{
					isLoading === true 
					? <SkeletonLoader_itemList/> //'loading'//<SkeletonDraggableList rows={4}/>
					: (
						users?.length <=0
						? <div className={`components--no_items`} >
							<div className="comps_no_items--title">No team member to display</div>
							<div className="comps_no_items--subtitle">The components of your website or application are the parts that allow it to function correctly. You can add some components here to view them.</div>
							<Button 
								component={Link} 
								to={`/team/new`}
								leftIcon={<Plus size={20} strokeWidth={2}/>}
								>Invite</Button>
							</div>
						: <>
                            <div >{items}</div>
                            {
                                isLoading === false && Math.ceil(totalRecords/ listPerPage) > 1 && 
                                <ReactPaginate
                                    previousLabel={""}
                                    nextLabel={""}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={Math.ceil(totalRecords/ listPerPage)} 
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={ async (e) => {
            
                                        const number = e.selected;
                                        //console.log(number);
            
                                        setActivePage(number) 
                                    }}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                    forcePage={activePage}
                                    />
                            }
                            </>
					)
					
					
				}
			 
			 
			 	
			
			<Routes>
				<Route 
					path={`/new`} 
					element={<Drawer
						title="Invite team member"
						closeModal={closeTeamMembersForm}
						isDisplay={true}
						
						>
						  <NewTeamMember onSuccess={ (response) => {
							  // setUsers.push(response)
							users.findIndex( x => x.id === response?.id ) < 0  && setUsers.insertAt( users.length > 0 ? 1 : 0 , response)

						}}/> 
					</Drawer>} />
				<Route 
					path={`/:user_id/permissions`} 
					element={<Drawer
						title="Edit permissions"
						closeModal={closeTeamMembersForm}
						isDisplay={true}
						>
						<EditPermissionsTeamMember onSuccess={ (response) => {
							const index = [...users].findIndex((p) => p.id === response?.id )
							setUsers.updateAt(index , response)
							 
						}}/>
					</Drawer>} />
			</Routes> 
			 
			 </Main>
		</>
	)
}
